import { render, staticRenderFns } from "./widgets-context-menu.vue?vue&type=template&id=557f917f&scoped=true&"
import script from "./widgets-context-menu.vue?vue&type=script&lang=js&"
export * from "./widgets-context-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f917f",
  null
  
)

export default component.exports